import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

export const useCopyEmail = (email: string) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const revision = useRef(0);

  useEffect(() => {
    setCopied(false);
    return () => {
      revision.current += 1;
      clearTimeout(timer.current);
    };
  }, [email]);

  const copy = async () => {
    const currentRevision = revision.current;
    try {
      await navigator.clipboard.writeText(email.trim());
      toast.success("Email copied to clipboard");
      if (revision.current === currentRevision) {
        setCopied(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setCopied(false), 2000);
      }
    } catch {
      if (revision.current === currentRevision) {
        setCopied(false);
        clearTimeout(timer.current);
      }
      toast.error("Couldn't copy the email. Select the address and copy it manually.");
    }
  };

  return { copied, copy };
};
